import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AddTeam from '../../components/modal/AddTeam';
import {
  createTeam,
  updateTeam,
  getTeamUsers,
  getOrganizationTeams,
} from '../../actions/teams';

class AddTeamDialog extends Component {
  static propTypes = {
    createTeam: PropTypes.func.isRequired,
    updateTeam: PropTypes.func.isRequired,
    getTeamUsers: PropTypes.func.isRequired,
    getOrganizationTeams: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div>
        <AddTeam
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.teams.isLoading,
  }),
  {
    createTeam,
    updateTeam,
    getTeamUsers,
    getOrganizationTeams,
  },
)(AddTeamDialog);
